import * as React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core';

/* UI */
import Button from '../../../Buttons/Button';
import { Typography } from '../../../typography/Typography';
import { VBox } from '@cube3/cubicle/src/core/templates/layout/Flex';
import { ModalMenuUI } from '../../../Modal/ModalMenuUI';

/// <Summary>
/// Base Modal for conformation
/// </Summary>

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    fieldSpacing: {
      marginTop: '20px',
      marginBottom: '20px'
    }
  })
);

interface Properties {
  submitDisabled: boolean;
  submitError: string;
  onSubmit: (ev: React.FormEvent) => void;
  onCloseEvent: () => void;
  loading: boolean;
  fields: React.ReactNode;
}

const ChangePasswordModalUI: React.FC<Properties> = (props) => {
  const {
    onCloseEvent,
    onSubmit,
    submitDisabled,
    submitError,
    loading,
    fields
  } = props;

  const classes = useStyles();

  return (
    <ModalMenuUI
      component="form" //important for forms
      extraComponentProps={
        //important for forms
        {
          onSubmit
        }
      }
      title={'Change your password'}
      onCloseEvent={onCloseEvent}
      loading={loading}
      footerRightComponent={
        <>
          <Button
            colorVariant={'ghost2'}
            text={'Cancel'}
            onClick={onCloseEvent}
          />
          <Button
            disabled={submitDisabled}
            text={'Save'}
            colorVariant={'filled1'}
            extraButtonProperties={{ type: 'submit' }} //important for forms
          />
        </>
      }
    >
      <VBox gap={16}>{fields}</VBox>

      {submitError && (
        <Typography color={'danger1'} className={classes.fieldSpacing}>
          {submitError}
        </Typography>
      )}
    </ModalMenuUI>
  );
};

export default ChangePasswordModalUI;
